import { AbstractSearchArgument } from '../global'
import { CONDITION_TYPE, DATE_PICKER_SHOW_TYPE, PLATFORM_LIST } from '@/utils/constants'

const platforms = []
PLATFORM_LIST.forEach(item => {
  platforms.push({
    value: item.id, label: item.title
  })
})

const SEARCH_CONDITION = [
  {
    name: 'status',
    title: '订单状态',
    placeholder: '请选择订单状态',
    type: CONDITION_TYPE.SELECT,
    value: '',
    visible: true,
    config: {
      list: [
        {value: '-1', label: '交易取消'},
        {value: '1', label: '待发货'},
        {value: '2', label: '待收货'},
        {value: '3', label: '交易成功'}
      ]
    }
  },
  {
    name: 'orderCode',
    title: '订单单号',
    placeholder: '请输入订单单号',
    type: CONDITION_TYPE.TEXT,
    value: '',
    visible: true
  },
  {
    name: 'date',
    title: '订单日期',
    placeholder: '',
    type: CONDITION_TYPE.DATE,
    value: '',
    visible: true,
    config: {
      type: DATE_PICKER_SHOW_TYPE.DATE_RANGE,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }
  }
]

class SearchArgument extends AbstractSearchArgument {
  constructor () {
    super()
    this.orderCode = ''
    this.startTime = ''
    this.endTime = ''
    this.status = ''
  }
}

export {
  SEARCH_CONDITION,
  SearchArgument
}



// WEBPACK FOOTER //
// ./src/models/client/my-order.js